<template>
  <section class="leftAsideElMainFrom">
    <leftAside
      v-if="$route.meta.showLeftAside"
      :menuData="menuData"
      :muneTitle="muneTitle"
      :acColor="acColor"
      :iconClass="iconClass"
    ></leftAside>
    <section
      class="leftAsideElMainSe relative"
      :style="{ width: rightMianWidth + 'px' }"
    >
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </section>
  </section>
</template>
<script>
import leftAside from "@/components/pcFrom/leftAside.vue";
import { menuData } from "@/views/rhqy/config/menuDataYw.js";
import { mapGetters } from "vuex";

export default {
  props: {},
  data() {
    return {
      menuData: menuData.children,
      muneTitle: menuData.menuName,
      iconClass: menuData.iconClass,
      acColor: "red",
      redirectMenu: {}
    };
  },
  watch: {
    $route(to, from) {
      const toArr = to.path.split("/");
      const fromArr = from.path.split("/");
      if (toArr[2] != fromArr[2]) {
        // this.getMenuData();
      }
    }
  },
  computed: {
    ...mapGetters(["rightMianWidth", "privilegeConfig"])
  },
  components: {
    leftAside
  },
  async mounted() {},
  methods: {},
  created() {
    let menuData = JSON.parse(JSON.stringify(this.menuData));
    this.menuData = this.$common.filterByPrivilege(
      menuData,
      this.privilegeConfig
    );
    // 进入第一个有权限的菜单
    if (this.$route.path == "/rhqy/service") {
      if (this.menuData[0].children) {
        this.$router.push(this.menuData[0].children[0].path);
      } else {
        this.$router.push(this.menuData[0].path);
      }
    }
  }
};
</script>
<style lang="less" scope>
.leftAsideElMainFrom {
  width: 100%;
  height: 100%;
  background: #ffffff;
  display: flex;
  .leftAsideElMainSe {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow-y: auto;
  }
}
</style>
